import {Plan} from "types";
import {getCombinedLidSize} from "./lid";
import {getVaultSize} from "./vault";
import {getFloorSize} from "./floor";
import {getIntermediateCeilingSize} from "./intermediateCeiling";
import {ElementSize} from "./elementSize";

export type GetSize = (plan: Plan) => ElementSize;

export const getCombinedSize = (getSizes: GetSize[], plan: Plan): ElementSize => {
    const getMinX = () => Math.min(...getSizes.map((f) => f(plan).x))
    const getMaxX = () => Math.max(...getSizes.map((f) => f(plan).x + f(plan).length))
    const getMinY = () => Math.min(...getSizes.map((f) => f(plan).y))
    const getMaxY = () => Math.max(...getSizes.map((f) => f(plan).y + f(plan).width))
    const getMaxHeight = () => Math.max(...getSizes.map((f) => f(plan).height))

    return {
        length: getMaxX() - getMinX(),
        width: getMaxY() - getMinY(),
        height: getMaxHeight(),
        x: getMinX(),
        y: getMinY()
    }
}

export const getLeftToLeft = (getSize: GetSize, getSizes: GetSize[], plan: Plan) =>
    getSize(plan).x - getCombinedSize(getSizes, plan).x

export const getTopToTop = (getSize: GetSize, getSizes: GetSize[], plan: Plan) =>
    (getCombinedSize(getSizes, plan).y + getCombinedSize(getSizes, plan).width)
    - (getSize(plan).y + getSize(plan).width)

export const getOverallSize =
    (plan: Plan) => getCombinedSize([getCombinedLidSize, getIntermediateCeilingSize, (plan: Plan) =>
        getVaultSize(plan, false), getFloorSize], plan)

export const getLidToIntermediateCeilingSpacing =
    (plan: Plan) => !!plan.lid && !!plan.intermediateCeiling && plan.lid.type !== 'subfloor'
        ? 3
        : 0
